import { format } from '@/utils/number';

function calculateColumnSummary({ property, values, columnsBehaviour, data }) {
  if (!columnsBehaviour[property]) return '';

  const currentColumnAction = columnsBehaviour[property];

  return format(currentColumnAction(values, data));
}

export default function calculateSummary({ columns, data, columnsBehaviour }) {
  return columns.map(({ property }) => {
    const values = data.map(item => Number(item[property]));

    const currentColumnSummary = calculateColumnSummary({
      property,
      values,
      columnsBehaviour,
      data,
    });

    return currentColumnSummary;
  });
}
